export { default } from "./MoneyInput";
